import React, { useContext } from "react";
import { Box, Divider, Stack } from "@mui/material";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { PaymentInformation } from "./paymentInformation";
import { PropertyDetailCard } from "./propertyDetailCard";

export const RightSideContent = React.memo(() => {
        const {transaction} = useContext(InvestTransactionContext);

    return (
        <Stack sx={{ width: { md: "calc(45% - 20px)", xs: "100%" }, height: "fit-content" }} spacing={{ md: !transaction ? 4 : 0, xs: 2 }}>
            {
                !transaction &&
                <PropertyDetailCard />
            }
            <Box sx={{ display: { md: "none", xs: "block" } }}>
                <Divider />
            </Box>
            <Box sx={{ display: { md: "block", xs: "none" } }}>
                <PaymentInformation />
            </Box>
        </Stack>
    )
})